const DEFAULT_RECAPTCHA_SITE_KEY = "";

export const RECAPTCHA_SITE_KEY = (
  import.meta.env.VITE_RECAPTCHA_SITE_KEY ?? DEFAULT_RECAPTCHA_SITE_KEY
).trim();

const RECAPTCHA_SCRIPT_PREFIX = "https://www.google.com/recaptcha/enterprise.js?render=";

export const ensureRecaptchaEnterpriseScript = (): HTMLScriptElement | null => {
  if (typeof document === "undefined" || !RECAPTCHA_SITE_KEY) return null;

  const existing = Array.from(document.scripts).find((script) =>
    script.src.startsWith(RECAPTCHA_SCRIPT_PREFIX)
  );
  if (existing instanceof HTMLScriptElement) {
    return existing;
  }

  const script = document.createElement("script");
  script.src = `${RECAPTCHA_SCRIPT_PREFIX}${encodeURIComponent(RECAPTCHA_SITE_KEY)}`;
  script.async = true;
  script.defer = true;
  script.dataset.recaptchaManaged = "1";
  document.head.appendChild(script);
  return script;
};
